import httpClient from "../lib/httpClient";

export const fetchImageUrl = async (bucket, key) => {
  // Ask S3 to return a signed URL for the image (in private bucket) and return it
  try {
    const { data } = await httpClient().get(`/proxy/imageSignedUrl?bucket=${bucket}&key=${key}`);

    return data.url;
  } catch (error) {
    console.error("Error fetching image URL:", error);
  }
  return null;
};

export const getBlobUrlFromS3 = async (bucket, key) => {
  // Ask S3 to return some data (typically,  image in private bucket) as a blob and then create a URL for it
  // Can be used to display the image in the browser, or pass its URL to some API.
  try {
    const response = await httpClient().get(`/proxy/getBlobFromS3?bucket=${bucket}&key=${key}`, {
      responseType: "blob",
    });

    const blob = await response.data;
    const url = URL.createObjectURL(blob);

    const verifyResponse = await fetch(url);
    if (!verifyResponse.ok) {
      console.error("Error verifying URL:", verifyResponse.statusText);
      return null;
    }
    const responseBlob = await verifyResponse.blob();
    if (false) {
      console.log("Response size:", responseBlob.size);
    }

    return url;
  } catch (error) {
    console.error("Error fetching image URL:", error);
  }
  return null;
};

export const getJsonFromS3 = async (bucket, key) => {
  // Ask S3 to return some data (typically,  JSON in a private bucket) and return it
  try {
    const gotResponse = await httpClient().get(`/proxy/getJsonFromS3?bucket=${bucket}&key=${key}`);

    if (gotResponse.status !== 200) {
      console.error("getJsonFromS3 Status:", gotResponse.status);
      return null;
    }

    return gotResponse.data;
  } catch (error) {
    console.error("getJsonFromS3 Error:", error);
  }
  return null;
};
